import { useSelector } from 'react-redux';
import { getCompany } from 'helpers/getCompanyVariables';
import images from 'constants/images';
import { companyRoles } from 'constants/enum';

const company = getCompany();

const isOneill = company === 'oneill';
const isSunshine = company === 'sunshine';

const generalOwnerZbookings = isOneill
  ? 'https://kerry-oneillmarketing1.zohobookings.com/#/4100793000000154136'
  : '';

// the general owner is the company-wide contact, shown when the agent has no
// dedicated consultant assigned to them
function resolveIsGeneralOwner(owner, user) {
  if (!owner || !user) return true;

  const isOwnerSuperAdmin = owner.id === companyRoles.superAdminId;
  if (isSunshine) return isOwnerSuperAdmin;

  const isAdmin = user['Position_at_Agency'] === 'Admin';
  const isLOA =
    user['Custom_Comp_Level'] === 'LOA' || user['Comp_LevelsX'] === 'LOA';

  if (isOwnerSuperAdmin || (isLOA && !isAdmin)) return true;
  if (owner.isInternalAgentConsultant || isAdmin) return false;

  return true;
}

/**
 * resolves the consultant an agent should contact, along with the copy and the
 * links every card that renders them needs
 */
export default function useAgentOwner() {
  const { loadingDashboard, owner } = useSelector(state => state.dashboard);
  const user = useSelector(state => state.user.zohoData);

  if (!owner || loadingDashboard) return { isReady: false };

  const isGeneralOwner = resolveIsGeneralOwner(owner, user);

  // only the oneill image set ships the agent success team photo
  const teamPhoto = images.agentSuccess?.teamPhoto;

  function resolveImageSrc() {
    if (!isGeneralOwner && owner?.imgURL) return owner.imgURL;
    if (isOneill && teamPhoto) return teamPhoto;
    return images.brand.placeHolder;
  }

  const imageSrc = resolveImageSrc();
  const displayEmail = isGeneralOwner
    ? companyRoles.email
    : owner.Email || 'No email available';

  return {
    isReady: true,
    isGeneralOwner,
    imageSrc,
    isTeamPhoto: imageSrc === teamPhoto,
    displayName: isGeneralOwner ? companyRoles.name : owner.Name,
    displayPhone: isGeneralOwner
      ? companyRoles.phone
      : owner.Phone || 'No phone available',
    displayEmail,
    hasEmail: Boolean(displayEmail?.includes('@')),
    bookingUrl:
      isGeneralOwner || !owner.zohoBooking
        ? generalOwnerZbookings
        : owner.zohoBooking
  };
}
